import React, {useContext} from "react";
import "./Contact.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import {illustration, contactInfo} from "../../portfolio";
import {Fade} from "react-reveal";
import email from "../../assets/lottie/email";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import StyleContext from "../../contexts/StyleContext";

export default function Contact() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main contact-margin-top" id="contact">
        <div className="contact-div-main">
          <div className="contact-copy">
            <h1 className="heading contact-title">Let’s build something that goes further.</h1>
            <p className={isDark ? "dark-mode contact-subtitle" : "subTitle contact-subtitle"}>
              {contactInfo.subtitle}
            </p>
            <a className="contact-cta" href={"mailto:" + contactInfo.email_address}>
              Start a conversation <span>↗</span>
            </a>
            <div className={isDark ? "dark-mode contact-text-div" : "contact-text-div"}>
              <a className="contact-detail-email" href={"mailto:" + contactInfo.email_address}>
                {contactInfo.email_address}
              </a>
              <SocialMedia />
            </div>
          </div>
          <div className="contact-image-div" aria-hidden="true">
            <span className="contact-orbit orbit-a" />
            <span className="contact-orbit orbit-b" />
            <span className="contact-signal signal-a" />
            <span className="contact-signal signal-b" />
            {illustration.animated ? (
              <DisplayLottie animationData={email} />
            ) : (
              <img
                alt="Man working"
                src={require("../../assets/images/contactMailDark.svg")}
              ></img>
            )}
          </div>
        </div>
      </div>
    </Fade>
  );
}
